export enum NewsType {
    News = "n",
    Bulletin = "b",
    Webinar = "w",
    Reports = "r",
    Notifications = "o",
    Meteorology = "m",
    Verification = "v",
    Hydrology = "h",
    Event = "e",
    AnnualMeetings = "a",
    UserFeedbackAndAnalyses = "s"
}
